import * as Blog_Domain_Types               from "../actions/types";
import * as viewElements                    from "../../../infrastructure/actions/creators/view-elements";
import * as Infrastructure_Provider_Actions from "../../../infrastructure/actions/creators/provider";
import api                                  from "../../../api";
import { put, takeLatest, all, call }       from "redux-saga/effects";

class BlogAsyncInterface {
  constructor() {
    this.name = "BlogAsyncInterface";
  }

  * getBlog(action) {
    try {
        yield put( Infrastructure_Provider_Actions.activateLoadingStatus('Get_Blog') );
        const resultData = yield call(
            api.fetch, {
                url: `/api/blogs`,
                method: 'GET',
            }
        );
        if(resultData){
            yield all([
                put({ 
                    type: Blog_Domain_Types.RESULT_GET_BLOG,
                    payload: resultData.data
                }),
            ])
        }
        yield put( Infrastructure_Provider_Actions.deactivateLoadingStatus('Get_Blog') );
    } catch(err){
        yield all([
          put(
            viewElements.createToast({
              position: "center top",
              type: "danger",
              title: "GET Blog unsuccessfully!",
              message: `${
                (err.response && err.response.data.message) ||
                err.message ||
                action.t("Static_Unexpected_Error_Occured")
              }`,
            })
          ),
          put(
            Infrastructure_Provider_Actions.deactivateLoadingStatus(
              "Get_Blog"
            )
          ),
        ]);
      }
  }

  * getBlogDetails(action) {
    try {
        yield put( Infrastructure_Provider_Actions.activateLoadingStatus('Get_Blog_Details') );
        const resultData = yield call(
            api.fetch, {
                url: `/api/blog/content`,
                method: 'GET',
                data: { 
                  "blog_id" : action.payload.id
                 },
                type : 'not_auth'
            }
        );
        console.log("saga result",resultData)
        if(resultData){
            yield all([
                put({ 
                    type: Blog_Domain_Types.RESULT_GET_BLOG_DETAILS,
                    payload: resultData.data
                }),
            ])
        }
        yield put( Infrastructure_Provider_Actions.deactivateLoadingStatus('Get_Blog_Details') );
    } catch(err){
        yield all([
          put(
            viewElements.createToast({
              position: "center top",
              type: "danger",
              title: "GET Blog Details unsuccessfully!",
              message: `${
                (err.response && err.response.data.message) ||
                err.message ||
                action.t("Static_Unexpected_Error_Occured")
              }`,
            })
          ),
          put(
            Infrastructure_Provider_Actions.deactivateLoadingStatus(
              "Get_Blog_Details"
            )
          ),
        ]);
      }
    }

  * removeBlog(action) {
    try {
        yield put( Infrastructure_Provider_Actions.activateLoadingStatus('Remove_Blog_Details') );
        const resultData = yield call(
            api.fetch, {
                url: `/api/blog`,
                method: 'DELETE',
                data: { 
                  "blog_id" : action.payload.id
                 },
                type : 'not_auth'
            }
        );
        if(resultData){
            yield all([
                put({ 
                    type: Blog_Domain_Types.RESULT_REMOVE_BLOG,
                    payload: resultData.data
                }),
            ])
        }
        yield put( Infrastructure_Provider_Actions.deactivateLoadingStatus('Remove_Blog_Details') );
    } catch(err){
        yield all([
          put(
            viewElements.createToast({
              position: "center top",
              type: "danger",
              title: "GET Blog Details unsuccessfully!",
              message: `${
                (err.response && err.response.data.message) ||
                err.message ||
                action.t("Static_Unexpected_Error_Occured")
              }`,
            })
          ),
          put(
            Infrastructure_Provider_Actions.deactivateLoadingStatus(
              "Remove_Blog_Details"
            )
          ),
        ]);
      }
    }

}

const blogSagaInterface = new BlogAsyncInterface();
export default function* blogConfigDomainAsyncInterface() {
  yield all([
    takeLatest(Blog_Domain_Types.GET_BLOG,                 blogSagaInterface.getBlog),
    takeLatest(Blog_Domain_Types.GET_BLOG_DETAILS,         blogSagaInterface.getBlogDetails),
    takeLatest(Blog_Domain_Types.REMOVE_BLOG,              blogSagaInterface.removeBlog),
  ]);
}
